<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="titleArea">
                <div class="titleText">技能认定成绩查询</div>
                <div class="titleButton">
                    <el-button class="custom-el-button" type="primary" @click="showHomePage">
                        <i class="el-icon-s-home"></i> 首页
                    </el-button>
                </div>
            </div>
            <div id="queryArea" class="filter-container">
                <div class="filter-container">
                    <div class="formItem">
                        <el-input v-model="queryForm.zsmc" placeholder="证书名称" style="width: 100%;"></el-input>
                    </div>
                </div>
                <div class="formItem text-center">
                    <el-button @click="handleFilter" type="gray" style="margin-left: 10px">
                        <i class="el-icon-search"></i>&nbsp;查询
                    </el-button>
                    <el-button @click="handleReset" type="gray" style="margin-left: 10px">
                        <i class="el-icon-refresh"></i>&nbsp;重置
                    </el-button>
                    <el-button @click="queryDialogVisible = true" type="primary">
                        <i class="el-icon-more"></i> 更多
                    </el-button>
                </div>
                <!--            <el-button @click="batchTg" type="success"><i class="el-icon-circle-check"></i>&nbsp;通过</el-button>-->
                <!--            <el-button @click="batchExport" type="primary"><i class="el-icon-download"></i>&nbsp;导出</el-button>-->
            </div>
            <el-dialog id="queryDialog" class="formDialog" title="查询信息" width="90%" :visible.sync="queryDialogVisible" v-if="queryDialogVisible">
                <el-row>
                    <el-input v-model="queryForm.zsmc" placeholder="证书名称" style="width: 100%;"></el-input>
                </el-row>
                <el-row>
                    <el-input v-model="queryForm.kh" placeholder="考号" style="width: 100%;"></el-input>
                </el-row>
                <el-row>
                    <el-input v-model="queryForm.xm" placeholder="姓名" style="width: 100%;"></el-input>
                </el-row>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button type="gray" @click="handleFilter">查 询</el-button>
                    <el-button style="margin-left: 10px;" type="gray" @click="handleReset">重 置</el-button>
                    <el-button style="margin-left: 10px;" @click="queryDialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>
            <div id="listArea">
                <!-- 列表区域 -->
                <el-table :data="tableData" @selection-change="handleSelectionChange" @current-change="handleCurrentChange" v-loading.body="tableLoading"
                          element-loading-text="信息加载中" stripe border fit highlight-current-row header-cell-class-name="tableHeadStyle"
                          :height="mainTableHeight" ref="mainTable">
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column label="序号" width="50" align="center">
                        <template slot-scope="scope">
                            <span>{{ (queryForm.pageNum - 1) * queryForm.rowNum + scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="证书名称" prop="zsmc" align="center" :formatter="formatzsmc"></el-table-column>
                    <el-table-column label="考号" prop="kh" align="center"></el-table-column>
                    <el-table-column label="姓名" prop="xm" align="center"></el-table-column>
                    <el-table-column label="总分" prop="zf" align="center"></el-table-column>
                    <el-table-column label="通过科目" prop="tgkm" align="center"></el-table-column>
                    <el-table-column label="状态" prop="tgzt" align="center" :formatter="formattgzt"></el-table-column>
                    <el-table-column label="操作" width="400px" align="center">
                        <template slot-scope="scope">
                            <el-button type="info" size="small" @click="infoRec(scope.row)">
                                <i class="el-icon-info"></i>&nbsp;详情
                            </el-button>
                            <!--                    <el-button type="success" size="small" @click="tgRec(scope.row)">-->
                            <!--                        <i class="el-icon-circle-check"></i>&nbsp;通过-->
                            <!--                    </el-button>-->
                            <el-button type="primary" size="small" @click="dzzsRec(scope.row)">
                                <i class="el-icon-circle-check"></i>&nbsp;电子证书
                            </el-button>
                            <!--                    <el-button type="primary" size="small" @click="uploadRec(scope.row)">-->
                            <!--                        <i class="el-icon-download"></i>&nbsp;下载证书-->
                            <!--                    </el-button>-->
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 分页区域 -->
                <div class="pagination-container">
                    <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange"
                                   :current-page.sync="queryForm.pageNum" :page-sizes="[10, 20, 50]" :page-size="queryForm.rowNum"
                                   layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
                </div>
            </div>


            <!-- 表单区域 -->
            <el-dialog class="customElRow" :title="CurdDialogTitle" :visible.sync="CurdDialogVisible" @closed="closeCurdDialog" width="800px" top="150px">
                <el-form ref="curdForm" :model="curdForm" label-width="120px" label-position="left" :rules="CurdRules">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="考号" prop="kh">
                                {{ curdForm.kh }}
                                <!--                            <el-input v-model="curdForm.kh" placeholder="请输入考号"></el-input>-->
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="姓名" prop="xm">
                                {{ curdForm.xm }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="证书名称" prop="zsmc">
                                {{ this.formatzsmc(curdForm) }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="总分" prop="zf">
                                {{ curdForm.zf }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="状态" prop="tgzt">
                                {{ this.formattgzt(curdForm) }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="考试课程">

                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <!-- 列表区域 -->
                <el-table :data="this.curdForm.kskctableData" @current-change="kskchandleCurrentChange" v-loading.body="kskctableLoading"
                          element-loading-text="信息加载中" stripe border fit highlight-current-row header-cell-class-name="tableHeadStyle"
                          :height="TableHeight" ref="kskcTable">
                    <el-table-column label="课程名称" prop="kcmc" align="center"></el-table-column>
                    <el-table-column label="课程类别" prop="kclb" align="center" :formatter="formatkclb"></el-table-column>
                    <el-table-column label="通过成绩" prop="tgcj" align="center"></el-table-column>
                    <el-table-column label="成绩" prop="zf" align="center"></el-table-column>
                </el-table>

                <div slot="footer" class="dialog-footer" style="margin-top: 10px">
                    <el-button type="primary" @click="handledzzs()">电子证书</el-button>
                    <!--                <el-button type="primary" @click="save()">保存</el-button>-->
                    <el-button @click="CurdDialogVisible = false">关闭</el-button>
                </div>
            </el-dialog>

            <el-dialog title="本校电子证书" class="dzzsDialog" width="60%" top="10vh" :visible.sync="dzzsDialogVisiable" @closed="closedzzsDialog" append-to-body>
                <stu-services-dzzs :key="timer" ref="dzzschild" style="height:73vh;" :transKsbmId="KsbmId"></stu-services-dzzs>
            </el-dialog>

        </div>
    </div>
</template>

<script>
import {confirmMsg, showNotify} from "utils/message";
import stuServicesDzzs from "../skillRecognition/stuServices/stuServicesDzzs";
import {globalConfig} from "../../../static/config";

export default {
    components: {stuServicesDzzs},
    data() {
        return {
            queryDialogVisible: false,
            fileList: [],
            loadingMask: null,
            queryForm: {
                pageNum: 1,
                rowNum: 10,
                zsmc: null,
                kh: null,
                xm: null,
            },
            //表单数据
            curdForm: {
                id: null,
                kh: null,//考号
                zh: null,//账号
                xm: null,//姓名
                ksbh: null,//考试编号
                zsmc: null,//证书名称
                kssj: null,//考试时间
                zf: null,//总分
                tgzt: null,//通过状态
                kskctableData: [],//考试课程列表
            },
            tableData: [],
            kskcData: [],
            MultipleSelection: [],//存放选中的数据
            XsbmMultipleSelection: [],//存放参加考试的数据
            tgbh: "",
            zsmc: [],//证书名称下拉数据
            tgzt: [],//通过状态下拉数据
            kclb: [],//课程类别下拉数据

            batchTgpd: [],//批量通过时存放每行未调整的数据

            currentPage: 1,
            limit: 10,
            total: null,
            tableLoading: true,
            selectRowData: null,
            mainTableHeight: 500,
            dialogTitle: "",
            dialogVisible: false,
            formSubmiting: false,
            editType: null,

            CurdDialogTitle: "",
            CurdDialogVisible: false,
            CurdRules: {},
            kskctableLoading: true,
            TableHeight: 300,
            editFlag: false,

            //导出证书pdf
            KsbmId: null,//记录考试报名id，导出pdf使用
            timer: '', //时间戳,点击重新加载子页面
            dzzsDialogVisiable: false,
            dzzsForm: {
                id: null,
            },

        };
    },
    created() {
        this.queryList();
        this.initCombo();
    },
    mounted() {
        this.$nextTick().then(() => {
            //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
            //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
            this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;
            this.topHeight = (window.innerHeight - 274 - 200) / 2 + 'px';

            // 监听窗口大小变化
            let self = this;
            window.onresize = function () {
                self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
            };
        });
    },
    methods: {
        formatzsmc(row) {
            return this.getValueByKey(this.zsmc, row.zsmc);
        },
        formattgzt(row) {
            return this.getValueByKey(this.tgzt, row.tgzt);
        },
        formatkclb(row) {
            return this.getValueByKey(this.kclb, row.kclb);
        },
        formatksqk(row) {
            return this.getValueByKey(this.ksqk, row.ksqk);
        },
        getValueByKey(arr, keyToFind) {
            const item = arr.find(item => item.comboValue === keyToFind);
            return item ? item.comboName : '';
        },
        queryList() {
            this.tableLoading = true;
            this.queryForm.pageNum = this.currentPage;
            this.queryForm.rowNum = this.limit;

            this.$api.gradesAssess.assessmentList.summaryStatisticslist({
                data: this.queryForm,
            }).then((response) => {
                this.total = response.data.data.total;
                this.tableData = response.data.data.list;
                this.tableLoading = false;
            }).catch((error) => {
                this.tableLoading = false;
                console.log(error);
            });
        },
        initCombo() {
            this.$api.gradesAssess.assessmentList.initCombo({}).then((res) => {
                this.zsmc = res.data.data.zsmc;
                this.tgzt = res.data.data.tgzt;
                this.kclb = res.data.data.kclb;
            }).catch((err) => {
                showNotify('错误', error, 'error', 3000);
            });
        },
        infoRec(rowData) {
            this.selectRowData = rowData;
            this.CurdDialogTitle = "详情";
            this.CurdDialogVisible = true;
            this.editFlag = true;
            this.$nextTick().then(() => {
                this.curdForm.id = this.selectRowData.id;
                this.curdForm.kh = this.selectRowData.kh;
                this.curdForm.zh = this.selectRowData.zh;
                this.curdForm.xm = this.selectRowData.xm;
                this.curdForm.ksbh = this.selectRowData.ksbh;
                this.curdForm.zsmc = this.selectRowData.zsmc;
                this.curdForm.zf = this.selectRowData.zf;
                this.curdForm.tgzt = this.selectRowData.tgzt;

                this.queryKskcByKsbh(this.curdForm);
            });
        },
        queryKskcByKsbh(data) {
            this.$api.gradesAssess.assessmentList.queryKskc({
                data: data,
            }).then((res) => {
                console.log('res...', res)
                this.curdForm.kskctableData = res.data.data.list;
                // this.tableLoading = false;
            }).catch((err) => {
                this.tableLoading = false;
                this.kskctableLoading = false;
                showNotify('错误', error, 'error', 3000);
            });
        },
        tgRec(rowData) {
            var message = '';
            message = '是否确认通过当前评定信息';
            confirmMsg(message).then(() => {
                this.tg(rowData);
            });
        },
        tg(data) {
            this.$api.gradesAssess.assessmentList.editTgzt({
                data: data,
            }).then((res) => {
                let state = res.data.data.State;
                switch (state) {
                    case 'Succees':
                        this.CurdDialogVisible = false;
                        showNotify('成功', '通过成功', 'success', 1500);
                        this.queryList();
                        break;
                    default:
                        showNotify('错误', '通过失败', 'error', 3000);
                        break;
                }
            }).catch((err) => {
                showNotify('错误', error, 'error', 3000);
            });
        },
        batchTg() {
            this.batchTgpd = this.MultipleSelection;
            if (this.MultipleSelection.length === 0) {
                this.$message({
                    title: '提示',
                    message: '请至少选择一条数据!',
                    type: 'warning',
                    duration: 2000,
                });
                return;
            }
            var message = '';
            message = '是否确认通过当前选择的评定信息';
            confirmMsg(message).then(() => {
                this.Alltg(this.batchTgpd[0]);
            });
        },
        Alltg(data) {
            this.$api.gradesAssess.assessmentList.editTgzt({
                data: data,
            }).then((res) => {
                let state = res.data.data.State;
                this.batchTgpd.splice(0, 1);
                if (this.batchTgpd.length > 0) {
                    this.Alltg(this.batchTgpd[0]);
                } else {
                    switch (state) {
                        case 'Succees':
                            this.CurdDialogVisible = false;
                            showNotify('成功', '通过成功', 'success', 1500);
                            this.queryList();
                            break;
                        default:
                            showNotify('错误', '通过失败', 'error', 3000);
                            break;
                    }
                }
            }).catch((err) => {
                showNotify('错误', error, 'error', 3000);
            });
        },
        handledzzs() {
            if (this.curdForm.tgzt === '1') {
                this.$message({
                    title: '提示',
                    message: '评定状态为未通过!',
                    type: 'warning',
                    duration: 2000,
                });
                return;
            }
            this.curdForm.tgzt
            this.KsbmId = this.curdForm.id;
            this.dzzsDialogVisiable = true;
        },
        dzzsRec(row) {
            if (row.tgzt === '1') {
                this.$message({
                    title: '提示',
                    message: '评定状态为未通过!',
                    type: 'warning',
                    duration: 2000,
                });
                return;
            }
            this.KsbmId = row.id;
            this.dzzsDialogVisiable = true;
        },
        closedzzsDialog() {
            this.dzzsDialogVisiable = false;
        },
        save() {
            this.$api.gradesAssess.assessmentList.editCjdj({
                data: this.curdForm,
            }).then((res) => {
                let state = res.data.data.State;
                switch (state) {
                    case 'Succees':
                        this.CurdDialogVisible = false;
                        showNotify('成功', '保存成功', 'success', 1500);
                        this.queryList();
                        break;
                    default:
                        showNotify('错误', '保存失败', 'error', 3000);
                        break;
                }
            }).catch((err) => {
                showNotify('错误', error, 'error', 3000);
            });
        },
        showLoadingMask(str) {
            this.loadingMask = this.$loading({
                lock: true,
                text: str,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.8)",
            });
        },
        closeLoadingMask() {
            if (this.loadingMask) this.loadingMask.close();
        },
        batchExport() {
            this.showLoadingMask("导出中，请稍候...");

            this.$api.gradesAssess.assessmentList.batchExport({
                responseType: "blob",
                data: this.queryForm,
            }).then((res) => {
                const _this = this;
                const resultData = res.data;

                console.log('------------', res.data)

                const fileReader = new FileReader();
                fileReader.onload = function () {
                    if (resultData.type == 'application/json') {
                        const jsonData = JSON.parse(fileReader.result); // 说明是普通对象数据，后台转换失败
                        showNotify('错误', jsonData.msg, 'error', 3000);
                    } else {
                        const fileName = decodeURI(res.headers['content-disposition'].split('fileName=')[1]);
                        _this.downloadFileByBlob(resultData, fileName);
                    }
                };
                fileReader.readAsText(resultData);
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.closeLoadingMask();
            });
        },

        downloadFileByBlob(data, fileName) {
            let blob = new Blob([data], {type: "application/ms-excel;charset=utf-8"});

            //浏览器兼容，Google和火狐支持a标签的download，IE不支持
            if (window.navigator && window.navigator.msSaveBlob) {
                window.navigator.msSaveBlob(blob, fileName);
            } else {
                let url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.setAttribute("href", url);
                link.setAttribute("download", fileName);
                link.click();
                link.remove();
                URL.revokeObjectURL(url);
            }
        },


        handleSelectionChange(val) {
            this.MultipleSelection = val;
            // for (let i = 0; i < this.MultipleSelection.length; i++) {
            //     if (i===0){
            //         this.tgbh = this.MultipleSelection[i].id;
            //     } else {
            //         this.tgbh = this.tgbh + ',' + this.MultipleSelection[i].id;
            //     }
            // }
            // //选中行数据，导入时使用
            // console.log('this.MultipleSelection',this.MultipleSelection)
            // console.log('通过编号：',this.tgbh)
        },
        kskchandleCurrentChange(val, old) {
            this.selectRowData = val;
        },
        //关闭对话框
        closeCurdDialog() {
            this.CurdDialogVisible = false;
            this.kskctableLoading = false;
            if (this.$refs['curdForm'] !== undefined) {
                this.$refs['curdForm'].clearValidate();
                this.$refs['curdForm'].resetFields();
            }
            this.queryForm.xm = null;
            this.queryForm.kh = null;
            this.queryForm.zsmc = null;
        },
        handleFilter() {
            this.currentPage = 1;
            this.queryList();
            this.queryDialogVisible = false;
        },
        handleReset() {
            this.limit = 10;
            this.currentPage = 1;
            this.tableLoading = false;
            this.queryList();
            this.queryForm.xm = null;
            this.queryForm.kh = null;
            this.queryForm.zsmc = null;
        },
        handlePageChange(val) {
            this.currentPage = val;
            this.queryList();
        },
        handleCurrentChange(val) {
            this.selectRowData = val;
        },
        handleSizeChange(val) {
            this.limit = val;
            this.currentPage = 1;
            this.queryList();
        },
        showHomePage() {
            this.$router.push('/m/wx/home');
        },

    },
};
</script>

<style scoped>
.customElRow .el-row {
    padding-bottom: 0;
}

#mobileMode {
    line-height: 0;
}

#mobileMode #queryDialog {
    top: 150px;
}

#mobileMode #mainDialogScroll {
    height: 25vh;
    padding: 10px 20px;
}

#mobileMode #printDialogScroll {
    height: 65vh;
    padding: 10px 20px;
}

#mobileMode #loadingTips {
    height: 30px;
    line-height: 30px;
    color: #9d9d9d;
    position: relative;
    bottom: 0;
    text-align: center;
}
</style>
<style src="styles/mobile.css"></style>
<style scoped>
#mobileMode #queryArea {
    height: 90px;
    margin: 10px 0 10px 0;
}

#mobileMode #queryDialog {
    top: 150px;
}

#mobileMode #mainDialogScroll {
    height: 65vh;
    padding: 10px 20px;
}

#mobileMode #loadingTips {
    height: 30px;
    line-height: 30px;
    color: #9d9d9d;
    position: relative;
    bottom: 0;
    text-align: center;
}

.el-dialog-div {
    height: 60vh;
    overflow: auto;
}

.attachmentUpload /deep/ .el-upload-dragger {
    width: 320px;
    height: 240px;
}

.maskStyle {
    width: 960px;
    overflow: hidden;
    background-color: #ffffff;
    filter: alpha(opacity=60);
    -moz-opacity: 0.6;
    opacity: 0.3;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 100;
}

.xsyjDialog {
    top: 20vh;
}

.maskStyle {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: none;
    background-color: #000000;
    filter: alpha(opacity=60);
    -moz-opacity: 0.6;
    opacity: 0.6;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 100;
}

.maskFont {
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    width: 230px;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -10px;
    margin-left: -90px;
}
</style>



// WEBPACK FOOTER //
// stuServicesAssessmentListMobile.vue?ec656b9e